import { HttpClient, HttpContext } from '@angular/common/http';
import { inject } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT, StrapiSingleEntityApiResponseOk } from '@core/const';
import { map, Observable } from 'rxjs';
import { StrapiBaseUrlService } from './base-url.service';

export class StrapiSingleEntityApiService<TAttributes extends object> {
  private readonly entityName: string;
  private readonly strapiBaseUrl = inject(StrapiBaseUrlService).baseApiUrl;
  private http: HttpClient = inject(HttpClient);

  constructor(entityName: string) {
    this.entityName = entityName;
  }

  getEntity(): Observable<{ id: number } & TAttributes> {
    return this.http
      .get<StrapiSingleEntityApiResponseOk<TAttributes>>(`${this.strapiBaseUrl}/${this.entityName}`, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, `${this.strapiBaseUrl}/${this.entityName}`),
      })
      .pipe(map((response) => ({ ...response.data }) as { id: number } & TAttributes));
  }

  // TODO: add create, update, delete methods
}
